import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map } from 'rxjs/operators';

@Injectable()
export class EventCategoryService {

  constructor(private base: BaseService) { }

  getToken = window.localStorage.getItem('token');


  save(data){
  	return this.base.post('/api/eventcategory-create', data);
  }

  getEventcategory(id){
    return this.base.post('/api/eventcategory-edit',{id:id});
  }

  eventcategoryUpdate(data){
    return this.base.post('/api/eventcategory-update',data);
  }

  eventcategoryDelete(id){
    return this.base.post('/api/eventcategory-delete',{id:id});
  }

  getAllEventcategory(){
    return  this.base.get('/api/get-eventcategory');
  }

}
